<template>
  <div class="app">
    <client-header ref="header"></client-header>

    <router-view> </router-view>
    <div class="cookie-notice" v-if="showCookieNotice">
      <div class="content">
        <p class="text-black ">
          Продолжая использовать наш сайт, вы даете согласие на обработку файлов cookie, которые обеспечивают правильную работу сайта и соглашаетесь с нашей
          <a href="/personal_data_policy" target="_blank">политикой обработки персональных данных</a>
          и
          <a href="/offerAndPrivacyPolicy" target="_blank">политикой конфиденциальности</a>.
        </p>
        <button class="button cookie_accept btn btn-color " @click="acceptCookies" style="width: auto!important;">Понятно</button>
      </div>
    </div>
  </div>

</template>

<style lang="scss">
.cookie-notice {
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
    background-color: #f0f0f0;
    padding: 10px;
    text-align: center;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 1000;
  }

  .cookie-notice a {
    color: #007bff;
    text-decoration: none;
  }
  .btn-color{

    background-color: #ED5500FF!important;
  }
  .cookie-notice a:hover {
    text-decoration: underline;
}
#app {
  background-color: #2D2D2DFF!important;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
<script>


import ClientHeader from "@/components/headers/ClientHeader.vue";
export default {
  components: {
    ClientHeader,
  },
  data() {
    return {
      navbarHeight: 0,
      showCookieNotice: true
    }
  },
  mounted() {
    this.$refs.header.$el.style.position = "fixed";
    this.navbarHeight = this.$refs.header.$el.offsetHeight;
    if (localStorage.getItem('cookieConsent') === 'true') {
      this.showCookieNotice = false;
    }
  },
  methods: {
    acceptCookies() {
      this.showCookieNotice = false;
      // Сохранение согласия в localStorage
      localStorage.setItem('cookieConsent', 'true');
    }
  }
}

</script>